import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@/contexts/LanguageContext';
import SEO from '@/components/SEO';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

export default function FAQPage() {
  const { t } = useTranslation('faq');
  const [openIndex, setOpenIndex] = useState(null);

  const items = t('items');
  const faqItems = Array.isArray(items) ? items : [];

  const faqSchema = faqItems.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": { "@type": "Answer", "text": item.a },
    })),
  } : undefined;

  return (
    <>
    <SEO title="FAQ" description="Questions fréquentes sur DestockPro. Comment acheter, vendre, booster vos annonces de matériel professionnel." path="/faq" schema={faqSchema} />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="faq-page">
      <section className="text-center mb-12">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#1F3F72] text-white mb-4">
          <HelpCircle className="w-6 h-6" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-neutral-900">{t('title')}</h1>
        <p className="text-base text-neutral-500 mt-2">{t('subtitle')}</p>
      </section>

      <section className="space-y-3" data-testid="faq-list">
        {faqItems.map((item, i) => (
          <div key={i} className="border rounded-xl overflow-hidden bg-white" data-testid={`faq-item-${i}`}>
            <button
              className="w-full flex items-center justify-between px-5 py-4 text-left text-sm font-medium text-neutral-900 hover:bg-neutral-50 transition-colors"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              {item.q}
              {openIndex === i ? <ChevronUp className="w-4 h-4 text-neutral-400 shrink-0" /> : <ChevronDown className="w-4 h-4 text-neutral-400 shrink-0" />}
            </button>
            {openIndex === i && (
              <div className="px-5 pb-4 text-sm text-neutral-600 leading-relaxed">
                {item.a}
              </div>
            )}
          </div>
        ))}
      </section>

      <div className="text-center mt-12">
        <p className="text-sm text-neutral-500 mb-3">{t('notFound')}</p>
        <Link to="/contact" className="text-sm font-medium text-[#F25C05] hover:underline" data-testid="faq-contact-link">
          {t('contactUs')}
        </Link>
      </div>
    </div>
    </>
  );
}